import { ShieldCheck, Clock, RotateCcw } from "lucide-react";

export default function CancellationPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="cancellation-policy-page">
      <h1 className="text-3xl sm:text-4xl font-display font-bold mb-2">Cancellation Policy</h1>
      <p className="text-[#717171] mb-8">Last updated {new Date().getFullYear()} · Ixitrip</p>

      <div className="grid sm:grid-cols-2 gap-4 mb-10">
        <div className="bg-[#E6F4EA] border border-[#B7E1C1] rounded-2xl p-5">
          <ShieldCheck className="w-6 h-6 text-[#137333] mb-2" />
          <p className="font-display font-semibold text-lg">Full refund</p>
          <p className="text-sm text-[#3c6b48]">Cancel <strong>48 hours or more</strong> before check-in and get <strong>100%</strong> of your reservation back.</p>
        </div>
        <div className="bg-[#FEF3E0] border border-[#F5D9A8] rounded-2xl p-5">
          <Clock className="w-6 h-6 text-[#B36B00] mb-2" />
          <p className="font-display font-semibold text-lg">50% refund</p>
          <p className="text-sm text-[#8a5a12]">Cancel <strong>less than 48 hours</strong> before check-in and get <strong>50%</strong> of your reservation back.</p>
        </div>
      </div>

      <div className="prose prose-sm max-w-none text-[#444] space-y-6">
        <section>
          <h2 className="font-display font-semibold text-xl text-[#222] mb-2">How it works</h2>
          <p>When you cancel a confirmed booking on Ixitrip, your refund is calculated based on how far in advance you cancel, measured against your check-in date and time:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li><strong>48+ hours before check-in:</strong> Full (100%) refund of the reservation amount.</li>
            <li><strong>Within 48 hours of check-in:</strong> 50% refund of the reservation amount.</li>
            <li><strong>After check-in / no-show:</strong> No refund.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-semibold text-xl text-[#222] mb-2">Fees &amp; taxes</h2>
          <p>The Ixitrip convenience fee and applicable GST on that fee are non-refundable. Government taxes (GST) on the reservation are refunded in proportion to the refunded amount.</p>
        </section>

        <section className="flex items-start gap-3">
          <RotateCcw className="w-5 h-5 text-[#FF385C] mt-1 shrink-0" />
          <div>
            <h2 className="font-display font-semibold text-xl text-[#222] mb-2">Refund timeline</h2>
            <p>Approved refunds are processed to your original payment method and typically appear within <strong>2–5 business days</strong>, depending on your bank or payment provider.</p>
          </div>
        </section>

        <section>
          <h2 className="font-display font-semibold text-xl text-[#222] mb-2">How to cancel</h2>
          <p>Go to <strong>My Bookings</strong>, open the reservation you want to cancel, and choose <strong>Cancel</strong>. You'll see the applicable refund before you confirm. Hosts and Ixitrip support can also cancel on your behalf where required.</p>
        </section>

        <p className="text-sm text-[#717171]">Questions about a cancellation or refund? Email us at <a href="mailto:customerservice@ixitrip.com" className="text-[#FF385C] font-medium">customerservice@ixitrip.com</a>.</p>
      </div>
    </div>
  );
}
